moment = require("moment")
_ = require("lodash")

DashboardFavoriteCourseCtrl = ($scope, DashboardService) ->
  $scope.isLoading = true
  $scope.favoriteCourses = []

  processData = (data) ->
    data.map (item) ->
      _.merge {}, item,
        play_date: moment(item.play_date).format("YYYY/MM/DD")

  createMyAnalysisParams = ->
    from: $scope.startDate
    to: $scope.endDate
    round_type: $scope.roundType

  callMyAnalysis = (params = {}) ->
    $scope.isLoading = true
    DashboardService.getFavoriteCourses(params)
      .then (res) ->
        $scope.favoriteCourses = processData(res.courses)
      .finally ->
        $scope.isLoading = false

  $scope.$parent.$on "periodSelected.gnp.dashboard", (event, startDate, endDate, roundType) ->
    $scope.startDate = startDate?.clone()
    $scope.endDate = endDate?.clone()
    $scope.roundType = roundType
    params = createMyAnalysisParams()
    callMyAnalysis(params)

  $scope.$parent.$on "roundTypeUpdated.gnp.dashboard", (event, roundType) ->
    $scope.roundType = roundType
    params = createMyAnalysisParams()
    callMyAnalysis(params)

DashboardFavoriteCourseCtrl.$inject = [
  '$scope'
  'DashboardService'
]

module.exports = DashboardFavoriteCourseCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/dashboard/favorite-course/favorite-course-controller.coffee